import React from 'react';
import { FileText, AlertCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Terminos = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center gap-3">
            <FileText className="h-12 w-12" />
            Términos y Condiciones
          </h1>
          <p className="text-xl opacity-90">Mora BioVet Laboratorio Veterinario</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">1. Aceptación de los términos</h2>
            <p className="text-gray-700">
              Al utilizar los servicios de Mora BioVet, el usuario acepta los presentes términos y condiciones.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">2. Servicios ofrecidos</h2>
            <p className="text-gray-700 mb-4">
              Mora BioVet proporciona servicios de análisis clínicos veterinarios con fines diagnósticos y de apoyo médico.
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
              <div className="flex items-start gap-2">
                <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                <p className="text-yellow-800 font-semibold">
                  Los resultados deben ser interpretados por un médico veterinario.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">3. Responsabilidad del usuario</h2>
            <p className="text-gray-700 mb-4">El usuario se compromete a:</p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Proporcionar información veraz del paciente</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Seguir las indicaciones pre-analíticas</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#84cc16] font-bold mt-1">•</span>
                <span>Consultar a un médico veterinario para diagnóstico</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">4. Limitación de responsabilidad</h2>
            <p className="text-gray-700 mb-4">Mora BioVet no se hace responsable por:</p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-red-500 font-bold mt-1">•</span>
                <span>Interpretaciones incorrectas realizadas por terceros</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-red-500 font-bold mt-1">•</span>
                <span>Uso indebido de los resultados</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-red-500 font-bold mt-1">•</span>
                <span>Consecuencias derivadas de omitir recomendaciones médicas</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">5. Tiempos de entrega</h2>
            <p className="text-gray-700">
              Los tiempos de entrega pueden variar dependiendo del tipo de estudio y condiciones operativas.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-lg mb-6">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">6. Modificaciones</h2>
            <p className="text-gray-700">
              Mora BioVet se reserva el derecho de actualizar estos términos en cualquier momento.
            </p>
          </CardContent>
        </Card>

        <div className="bg-blue-50 border-l-4 border-[#1e40af] p-6 rounded-lg mt-8">
          <p className="text-gray-700">
            <strong>Última actualización:</strong> Marzo 2026
          </p>
          <p className="text-gray-600 mt-2 text-sm">
            Para consultas sobre estos términos, contacta a: info@morabiovet.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terminos;